<template>
  <div class="[ mk-ordershow ]">
    <div class="row mx-0">
      <div class="container pt-4">
        <div class="row">
          <div class="col col-sm-10 mx-auto align-self-center">
            <div>
              <a href="/orders" class="text-success">
                <i class="far pr-2 fa-chevron-left"></i>
                <strong>Back</strong></a>
            </div>
            <div class="d-flex align-items-center justify-content-between my-4">
              <h1>
                {{ `Order # ${order.id}` }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- Show order details card -->
      <div class="row mb-3">
        <div class="col-12 col-sm-10 mx-auto">
          <div class="account-card card mb-5">
            <div class="">
              <!-- Steps -->
              <div class="order-steps">
                <el-steps v-if="this.order.order_status_id != 2" :space="200" :active="step" finish-status="success"
                  simple>
                  <el-step title="Order Placed"></el-step>
                  <el-step title="Order Confirmed"></el-step>
                  <el-step :title="
                    order.order_type_id != 3 ? 'Delivered' : 'Picked up'
                  "></el-step>
                </el-steps>
                <div v-else class="alert alert-warning">Order Cancelled</div>
              </div>

              <!-- Details -->
              <h2 class="mt-4">
                {{ order.order_type_id != 3 ? "Delivery" : "Order" }} detail
              </h2>
              <hr />
              <div class="row">
                <div class="col-4" v-if="order.order_type_id != 3">
                  <div>
                    <p class="font-18 mb-1"><strong>Address</strong></p>
                  </div>
                  <div>
                    <p class="mb-1">{{ order.site_contact_name }}</p>
                  </div>
                  <div>
                    <p>{{ order.address }}</p>
                  </div>
                </div>
                <div class="col-4" v-if="order.order_type_id != 3">
                  <div>
                    <p class="font-18 mb-1"><strong>Phone number</strong></p>
                  </div>
                  <div>{{ order.site_contact_phone }}</div>
                </div>
                <div class="col-4">
                  <div>
                    <p class="font-18 mb-1">
                      <strong>{{
                          order.order_type_id != 3 ? "Delivery" : "Pickup"
                      }}
                        Date</strong>
                    </p>
                  </div>
                  <div>
                    {{ order.delivery_date ? moment(order.delivery_date).format("DD MMM YYYY"): 'N/A' }}
                  </div>
                </div>
              </div>
              <div class="row mt-3" v-if="order.delivery_notes">
                <div class="col-12">
                  <div>
                    <p class="font-18 mb-1">
                      <strong>{{
                          order.order_type_id != 3 ? "Delivery" : "Pickup"
                      }} Notes</strong>
                    </p>
                  </div>
                  <div>{{ order.delivery_notes }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End show order details card -->

        <!-- Your order details -->
        <div class="col-12 col-sm-10 mx-auto">
          <div class="account-card card mb-5">
            <div class="">
              <h2>Your order</h2>
              <hr class="mb-4" />
              <div class="row">
                <div class="col-1"></div>
                <div class="col-5">
                  <p class="mb-0">
                    <strong class="text-black-500 text-uppercase font-14">Turf Type</strong>
                  </p>
                </div>
                <div class="col-3">
                  <p class="mb-0">
                    <strong class="text-black-500 text-uppercase font-14">Quantity (m2)</strong>
                  </p>
                </div>
                <div class="col-3">
                  <p class="mb-0">
                    <strong class="text-black-500 text-uppercase font-14">Price (ex GST)</strong>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row" v-for="item in order.items" v-bind:key="item.id">
                <div class="col-1 d-flex align-items-center">
                  <img v-if="item.grass_id && item.grass && item.grass.thumbnail" :src="item.grass.thumbnail.url"
                    width="100%" />
                </div>
                <div class="col-5 d-flex align-items-center">
                  <p class="mb-0">
                    <strong>{{ item.grass.full_name }}</strong>
                  </p>
                </div>
                <div class="col-3 d-flex align-items-center">
                  <p class="mb-0">{{ item.size_sqm }}</p>
                </div>
                <div class="col-3 d-flex align-items-center">
                  <p class="mb-0">
                    {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(item.size_sqm_turf_dollar_price))
                    }}
                    <!-- / sqm -->
                  </p>
                </div>
                <div class="col-12">
                  <hr />
                </div>
              </div>
              <div class="row d-flex align-items-center justify-content-between mt-4">
                <div class="col-12 d-flex justify-content-between">
                  <p class="font-18">Subtotal</p>
                  <p class="font-18">
                    {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(
                          Number(
                            reduceArray(
                              this.order.items,
                              "size_sqm_turf_dollar_price"
                            )
                          )
                        )
                    }}
                  </p>
                </div>
              </div>
              <div class="row d-flex align-items-center justify-content-between" v-if="order.order_type_id == 2">
                <div class="col-12 d-flex justify-content-between">
                  <p class="font-18">Laying</p>
                  <p class="font-18">
                    {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(order.laying_dollar_price))
                    }}
                  </p>
                </div>
              </div>

              <div class="row" v-if="[1, 2].includes(order.order_type_id)">
                <div class="col-12 d-flex justify-content-between">
                  <p class="font-18">Delivery</p>
                  <p class="font-18">
                    {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(order.freight_dollar_price))
                    }}
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-12 d-flex justify-content-between">
                  <p class="font-18">GST</p>
                  <p class="font-18">
                    {{
                        new Intl.NumberFormat("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        }).format(Number(gstOrder))
                    }}
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-12 d-flex justify-content-between">
                  <p class="mb-0 font-22"><strong>Total</strong></p>
                  <p class="mb-0 font-22">
                    <strong>
                      {{
                          new Intl.NumberFormat("en-AU", {
                            style: "currency",
                            currency: "AUD",
                          }).format(Number(totalOrder))
                      }}
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Your order details -->

        <!-- If invoice, show invoice details -->
        <div class="col-12 col-sm-10 mx-auto" v-if="
          order.invoice_number && order.invoice && !order.invoice.deleted_at
        ">
          <div class="account-card card mb-5">
            <div class="">
              <h2>Invoice # {{ order.invoice_number }}</h2>
              <hr />
              <div class="row mb-3">
                <div class="col-8">
                  <div class="font-weight-bold">Xero ID</div>
                  {{ order.invoice.xero_id }}
                </div>
                <div class="col-4 text-right" v-if="localInvoiceStatus.id == 2">
                  <a :href="`/orders/${order.id}/invoice`" class="btn-primary-outline" target="_blank"
                    style="max-width: 200px;float: right;">
                    <i class="far fa-download mr-2"></i> Download Invoice</a>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <div class="font-weight-bold">Sawfish Status</div>
                  <strong>
                    <span>
                      {{ order.invoice.sawfish_invoice_status }}
                    </span>
                  </strong>
                </div>
                <div class="col-2">
                  <div class="font-weight-bold">Invoice Status</div>
                  <strong v-if="localInvoiceStatus" :class="{
                    'text-blue': localInvoiceStatus.id == 1,
                    'text-green': localInvoiceStatus.id == 2,
                  }">
                    {{ localInvoiceStatus.name }}
                  </strong>
                </div>
                <div class="col-2">
                  <div class="font-weight-bold">Amount Paid</div>
                  ${{
                      Number(order.invoice.amount_paid).toLocaleString("en-AU", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                  }}
                </div>
                <div class="col-2">
                  <div class="font-weight-bold">Amount Due</div>
                  ${{
                      Number(order.invoice.amount_due).toLocaleString("en-AU", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End If invoice, show invoice details -->
      </div>
    </div>
  </div>
</template>
<script>
import Order from "../../models/customer/Order";
import InvoiceStatus from "../../../global/constants/InvoiceStatus";
export default {
  components: {},
  props: {
    initial_order: {
      type: Object,
    },
  },
  data() {
    return {
      order: new Order(this.initial_order),
    };
  },
  created() { },
  computed: {
    step() {
      if ([8, 13].includes(this.order.order_status_id)) return 3;

      if (this.order.order_status_id != 2 && this.order.confirmation_sent)
        return 2;

      if (this.order.order_status_id != 2) return 1;

      return 0;
    },
    gstOrder() {
      if (this.order.items.length || this.order.care_items.length) {
        return (
          Number(
            this.reduceArray(this.order.items, "size_sqm_turf_dollar_price") +
            this.order.freight_dollar_price +
            this.order.laying_dollar_price
          ) / 10
        ).toFixed(2);
      }

      return 0;
    },
    totalOrder() {
      return (
        Number(this.order.freight_dollar_price) +
        Number(this.order.laying_dollar_price) +
        Number(
          this.reduceArray(this.order.items, "size_sqm_turf_dollar_price")
        ) +
        Number(this.gstOrder)
      );
    },
    xeroResponse() {
      if (this.order.invoice && this.order.invoice.response) {
        let response = JSON.parse(this.order.invoice.response);
        if (Array.isArray(response)) {
          // if it is an array
          return response[0];
        } else return response;
      }
      return null;
    },
    invoiceStatuses() {
      return Object.keys(InvoiceStatus).map((key) => {
        return InvoiceStatus[key];
      });
    },
    localInvoiceStatus() {
      return this.invoiceStatuses.find(
        (status) => status.id == this.order.invoice.xero_status
      );
    },
  },
  methods: {
    reduceArray(object, key) {
      if (object) {
        return object.reduce(function (accumulator, currentValue) {
          return accumulator + parseFloat(currentValue[key]);
        }, 0);
      } else {
        return 0;
      }
    },
  },
};
</script>
